import areaDlgMul from "./areaDlgMul.js";
import subjectDlgMul from "./subjectDlgMul.js";

const reportMan = {
  namespaced: true,
  modules: {
    areaDlgMul,
    subjectDlgMul
  }
};

export default reportMan;
